// 引入组件
import EditableChart from './editable-chart'

EditableChart.install = Vue => Vue.component(EditableChart.name, EditableChart);

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(EditableChart);
 
}

export default EditableChart



// WEBPACK FOOTER //
// ./src/packages/editable-chart/index.js